//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import {fetchFilter} from "@/api/master";
import {fetchCheckDocument} from "@/api/checkDocument"
import {Message} from "element-ui";
import func from "@/utils/decoded";
import {fetchReportStep1} from "@/api/report";
// import usersData from '../admin/UsersData'

const fields = [
	{key: 'contract_id', label: 'เลขที่สัญญา', _style: 'min-width:100px'},
	{key: 'name_customer', label: 'ชื่อ-สกุล', _style: 'min-width:150px;'},
	{key: 'start_date_contract', label: 'วันที่เริ่มทำสัญญา', _style: 'min-width:100px;'},
	{key: 'balance', label: 'ยอดเงินคงเหลือ', _style: 'min-width:100px; text-align: right;'},
	{key: 'status_id', label: 'สถานะ', _style: 'min-width:100px;'},
	{key: 'process_day', label: 'เวลาดำเนินการ', _style: 'min-width:50px; text-align: center;'},
	{
		key: 'show_details',
		label: 'รายละเอียด',
		_style: 'min-width:150px; text-align: center;',
		sorter: false,
		filter: false
	}
]

export default {
	name: 'CheckDocument',
	data() {
		return {
			options: [],
			items: [],
			fields,
			filterParams: {
				stepId: 1
			},
			searchParams: {
				keyword: '',
				startDate: '',
				endDate: '',
				filter: 0
			},
			balanceFormat: {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			},
			privilege: {read: false, write: false, report: false}
		}
	},
	watch: {
		$route: {
			immediate: true,
			handler(route) {
				if (route.query && route.query.page) {
					this.activePage = Number(route.query.page)
				}
			}
		}
	},
	async mounted() {
		this.$store.state.loading = true
		try {
			this.searchParams.endDate = moment().format('YYYY-MM-DD')
			this.searchParams.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD')
			await new Promise((resolve, reject) => {
				fetchFilter(this.filterParams).then(response => {
					const check = response.header
					const data = response.body
					if (check.error === 'N') {
						this.options = data
						resolve()
					}
				}).catch(error => {
					this.errorMsg = error
					console.log(error)
					reject(error)
				})
			})
			await this.getDataList()
		} finally {
			this.$store.state.loading = false
		}

		const check = func.checkMenu(this.$route.path)
		if (check && check.length > 0) {
			this.privilege = check[0]
		}
	},
	methods: {
		async getDataList() {
      this.items = []
			await fetchCheckDocument(this.searchParams).then(res => {
				this.items = []
				const check = res.header;
				const data = res.body;
				if (check.error == 'N') {
					for (let item of data) {
						if (item.status_id == 2) {
							item.status_id = 'ตรวจสอบเอกสาร[เรียบร้อย]'
						} else if (item.status_id == 1) {
							item.status_id = 'ตรวจสอบเอกสาร[ไม่เรียบร้อย]'
						} else {
							item.status_id = 'รอดำเนินการ'
						}
						this.items.push(item)
					}
				}
			}).catch(error => {
				Message({
					message: 'มีข้อผิดพลาด กรุณาติดต่อผู้ดูแลระบบ',
					type: 'error',
					duration: 5 * 1000,
				})
				this.errorMsg = error
				console.log(error)
			})
		},
		getBadge(status) {
			switch (status) {
				case 'ตรวจสอบเอกสาร[เรียบร้อย]':
					return 'success'
				case 'Inactive':
					return 'secondary'
				case 'รอดำเนินการ':
					return 'warning'
				case 'ตรวจสอบเอกสาร[ไม่เรียบร้อย]':
					return 'danger'
				default:
					return 'primary'
			}
		},
		handleContractExport() {
			const loading = this.$loading({
				lock: true,
				text: 'Please wait',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			})

			fetchReportStep1(this.searchParams).then(response => {
				const fileURL = window.URL.createObjectURL(new Blob([response]))
				const fileName = 'Step1_' + func.generateReportDate() + '.xlsx'
				const link = document.createElement('a')

				link.href = fileURL
				link.setAttribute('download', fileName)
				document.body.appendChild(link)
				loading.close()
				if (response.size > 0 && response.type !== 'application/json') {
					link.click()
				} else {
					this.$notify({
						title: 'Error',
						message: 'ไม่สามารถสร้างรายงานการตรวจสอบเอกสาร',
						type: 'error',
						duration: 5000
					})
				}
				link.remove()

				// Just to simulate the time of the request
				setTimeout(() => {
					loading.close()
				}, 1.5 * 1000)
			})
		},
		rowClickDetail(item) {
			this.$router.push({path: `/step1/CheckDocumentDetail/${item.contract_id}`})
		},
		pageChange(val) {
			this.$router.push({query: {page: val}})
		}
	}
}
